<template>
  <div class="dashboard-overview" id="bodyId">
    <!--loading section-->
    <div class="panel" v-if="isLoading">
      <div class="panel__content">
        <div class="loaderContainer">
          <img src="/static/wave.gif" alt="" width="32" height="32">
        </div>
      </div>
    </div>
    <div v-else>
      <!-- Main Body layout -->
      <!--payment summary-->


      <div style="display: flex; flex-direction: row-reverse;">
        <div  @click="paymentSummary(c.currency.id)" class="link" style="cursor: pointer" v-for="c in overviewData.wallets" :key="c.id">
           &nbsp; {{c.currency.shortCode}}
        </div>
      </div>


      <div style="clear: both"></div>
      <section class="payment__summary outer-container">
        <div class="payment__summary--daily">
          <div class="card card__height-reset">
            <div class="card__content card__content--flex">
              <div class="content__left">
                <div class="daily-total" v-if="paymentSummaryToday.currency">{{paymentSummaryToday.currency}} {{paymentSummaryToday.value_today | numeralize('0,0.00')}}</div>
                <div class="daily-total" v-if="!paymentSummaryToday.currency">0.00</div>
              </div>

              <div class="content__right">
                <div class="payment-text">
                  <div class="payment-text__upper">Payments sent today</div>
                  <div class="payment-text__bottom" v-if="paymentSummaryToday.currency" ><span>to </span>{{paymentSummaryToday.volume_today | numeralize('0,0')}} people </div>
                  <div class="payment-text__bottom" v-if="!paymentSummaryToday.currency"><span>to </span>0 Contacts</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="payment__summary--daily">
          <div class="card card__height-reset">
            <div class="card__content card__content--flex">
              <div class="content__left">
                <div class="daily-total" v-if="paymentSummaryWeek.currency">{{paymentSummaryWeek.currency}} {{paymentSummaryWeek.value_today | numeralize('0,0.00')}}</div>
                <div class="daily-total" v-if="!paymentSummaryWeek.currency">0.00</div>
              </div>
              <div class="content__right">
                <div class="payment-text">
                  <div class="payment-text__upper">Payments sent this week</div>
                  <div class="payment-text__bottom" v-if="paymentSummaryWeek.currency"><span>to </span>{{paymentSummaryWeek.volume_today | numeralize('0,0')}} people</div>
                  <div class="payment-text__bottom" v-if="!paymentSummaryWeek.currency"><span>to </span>0 Contacts</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!--recent balances-->
      <section class="panel wallet-balance">
        <div class="panel__header">
          <div class="panel__header__left">Your Wallet <span>balances</span></div>
        </div>
        <div class="panel__content panel__content--grey outer-container">
          <div class="wallets--lower overview__wallets wallet__cash__balances" v-if="!isLoading">
            <!--wallet-->
            <div class="cash__balance card" v-for="currency in overviewData.wallets">
              <router-link :to="{name: 'single-balance-details', params: { id: currency.id }}" class="default-style">
                <div class="card__content">
                  <div class="cash__balance__amount">
                    <span class="cash__balance__currency">{{currency.currency.symbol}}</span>
                    {{ currency.balance | numeralize('0,0.00') }}
                  </div>
                  <div class="cash__balance__deets">
                    <div class="wallet__cash__flag-thumbnail">
                      <svg class="icon-flag icon--sm"><use v-bind="{'xlink:href':'/static/icons.svg#icon-flag-'+ toLowerCase(currency.currency.shortCode)}"></use></svg>
                    </div>
                    <div class="wallet__cash__name">{{currency.currency.shortCode}} balance</div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </section>


      <!--recent payments-->
      <section class="panel transactions">
        <div class="panel__header">
          <div class="panel__header__left">Recent <span>Payments</span>
            <!-- <div class="tag__notifications tag__notifications--circle tag--above-text" v-if="!isLoading">{{overviewData.transactions.length}}</div> -->
          </div>
        </div>
        <div class="panel__content panel__content--grey">
          <!--if object is empty-->
          <div class="panel__empty" v-if="recentPaymentsEmpty">
            <div class="panel__empty__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="92" height="70" viewBox="0 0 92 70"><g fill="none" fill-rule="evenodd" transform="translate(-1 -1)"><rect width="43" height="60" x="10" y="6" fill="#D6DBEB" opacity=".269" rx="3" transform="rotate(-22 31.5 36)"></rect> <rect width="43" height="60" x="41" y="6" fill="#D6DBEB" opacity=".269" rx="3" transform="rotate(22 62.5 36)"></rect> <g fill-rule="nonzero"><g transform="translate(47 45)"><path fill="#4B536B" d="M10.968.279a5.039 5.039 0 1 0 .001 10.077A5.039 5.039 0 0 0 10.968.28zm2.178 7.326c-.134.27-.32.495-.562.676a2.561 2.561 0 0 1-.859.408c-.13.037-.266.064-.404.086v.591h-.775v-.542a4.194 4.194 0 0 1-.562-.05 3.82 3.82 0 0 1-.569-.134 2.764 2.764 0 0 1-.418-.164 1.021 1.021 0 0 1-.244-.156.474.474 0 0 1-.118-.23 1.924 1.924 0 0 1-.042-.465c0-.135.004-.243.014-.324a.776.776 0 0 1 .042-.195c.019-.049.042-.082.069-.098a.21.21 0 0 1 .105-.024c.052 0 .127.029.227.087.101.058.225.122.374.191.149.071.322.135.52.195s.422.091.673.091c.159 0 .299-.015.422-.048s.23-.079.321-.14a.593.593 0 0 0 .207-.23.702.702 0 0 0 .069-.321.535.535 0 0 0-.128-.359 1.128 1.128 0 0 0-.343-.262 3.983 3.983 0 0 0-.481-.209 11.381 11.381 0 0 1-.552-.217 5.015 5.015 0 0 1-.55-.272 2.077 2.077 0 0 1-.482-.377 1.694 1.694 0 0 1-.341-.538 1.956 1.956 0 0 1-.13-.753c0-.297.058-.571.175-.82.116-.248.283-.461.503-.639.218-.176.485-.314.799-.412.14-.043.288-.077.443-.101v-.582h.775v.54a4.14 4.14 0 0 1 .907.143c.149.042.275.088.377.136.102.049.176.091.22.126a.315.315 0 0 1 .093.105.454.454 0 0 1 .043.126 2.556 2.556 0 0 1 .034.449c0 .126-.003.228-.01.307a.779.779 0 0 1-.035.189c-.016.045-.038.077-.065.093a.193.193 0 0 1-.098.025.484.484 0 0 1-.195-.073 3.307 3.307 0 0 0-.331-.157 4.035 4.035 0 0 0-.461-.157 2.205 2.205 0 0 0-.596-.073c-.159 0-.296.016-.412.049a.773.773 0 0 0-.286.14.61.61 0 0 0-.225.474c0 .145.044.266.134.363.088.098.204.184.349.258.144.076.307.145.491.21.184.064.37.136.558.213.189.077.375.166.559.268.183.102.348.228.491.377.145.149.261.327.349.534.088.207.132.452.132.736a2.148 2.148 0 0 1-.201.936z"></path> <circle cx="2.34" cy="5.317" r="1.679" fill="#D6DBEB"></circle> <circle cx="19.596" cy="5.317" r="1.679" fill="#D6DBEB"></circle></g> <path fill="#4B536B" d="M72.194 41.635H43.742c-.785 0-1.421.563-1.421 1.257v14.852c0 .694.636 1.257 1.421 1.257h28.451c.785 0 1.421-.563 1.421-1.257V42.892c.001-.695-.635-1.257-1.42-1.257zM44.59 54.338v-7.357c.987-.009 3.28-.352 3.286-3.34h20.221c.017.994.381 3.197 3.25 3.247v7.377c-.963.036-2.84.409-3.122 2.729h-20.32c-.164-1.108-.837-2.65-3.315-2.656z"></path> <g fill="#4B536B"><path d="M35.6 25.5h4.466v4.466H35.6zM43.615 25.5h4.466v4.466h-4.466zM51.631 25.5h4.466v4.466h-4.466zM27.584 32.291h4.466v4.466h-4.466zM27.584 25.5h4.466v4.466h-4.466zM35.6 32.291h4.466v4.466H35.6zM43.615 32.291h4.466v4.466h-4.466zM51.631 32.291h4.466v4.466h-4.466zM27.584 39.081h4.466v4.466h-4.466zM39.724 42.892c0-.553.123-1.079.342-1.554v-2.256H35.6v4.466h4.124v-.656z"></path> <g><path d="M31.147 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.669 1.488-1.488 1.488zM41.873 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.669 1.488-1.488 1.488zM52.599 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.67 1.488-1.488 1.488z"></path> <path d="M57.022 12.124h-1.079v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636h-3.974v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636h-3.974v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636H26.66c-4.563 0-8.274 3.712-8.274 8.274v20.375c0 4.563 3.712 8.274 8.274 8.274h13.064v-3.711H26.66a4.568 4.568 0 0 1-4.563-4.563V23.435h39.489v15.602h3.711V20.399c-.001-4.563-3.712-8.275-8.275-8.275z"></path></g></g></g></g></svg>
            </div>
            <div class="panel__empty__text">You have made no recent payments.
              <router-link :to="{name:'fund-wallet'}" class="link">Fund your wallet </router-link> to
              <router-link :to="{name:'single-disburse'}" class="link">send money</router-link> to a beneficiary
            </div>
          </div>
          <!-- Table Data -->
          <transition name="slide-fade">
            <div class="table">
              <!-- Table body -->
              <div class="table__section table__section--body"  v-for="transaction in overviewData.transactions">
                <!-- table row -->
                <!--<div  class="table">-->
                <div class="table__row">
                  <!-- table data -->

                  <div class="table__data">
                    <div class="table__data--bold">
                      <small class="table__data--result">{{transaction.currency.shortCode}}</small> <br>
                      {{ transaction.amount | numeralize('0,0.00') }}
                    </div>
                  </div>
                  <!-- table data -->
                  <div class="table__data">
                    <div class="table__data--default" v-if="transaction.beneficiary">{{toLowerCase(transaction.beneficiary.accountName)}}</div>
                    <div class="table__data--default" v-if="!transaction.beneficiary">Unavailable</div>
                    <div class="table__data--sub" v-if="transaction.beneficiary">{{transaction.beneficiary.bankName}} {{transaction.beneficiary.accountNumber}}</div>
                  </div>
                  <!-- table data -->
                  <div class="table__data">
                    <div class="table__data--default">{{ createdAgo(transaction.createdAt) }}</div>
                    <div class="table__data--sub">{{ momentDate(transaction.createdAt) }}</div>
                  </div>

                  <!-- table data -->
                  <div class="table__data">
                    <div class="table__data--default">
                      <span v-if="transaction.reversed" class="tag" :class="['tag--reversed']">Reversed</span>
                      <span v-else class="tag" :class="['tag--' + transaction.status]">{{transaction.status}}</span>
                    </div>
                  </div>

                  <!-- table data -->
                  <div class="table__data">
                    <div class="table__data--default">Sent From
                      <br>
                    <span class="table__data--result"> {{transaction.currency.shortCode}} Wallet </span></div>
                  </div>

                  <!-- table data -->
                  <div class="table__data">
                    <router-link :to="{name:'single-transfer', params: {id: transaction.id}}" class="btn btn--default btn--compact">View</router-link>
                  </div>
                </div>
                <div class="table__row spacer"></div>
                <!--</div>-->
                <!--show if show more is true-->
              </div>
              <div class="table__section table__section--body" v-if="!recentPaymentsEmpty">
                <div class="table__row table__row__empty">
                  <div class="table__data"></div>
                  <div class="table__data"></div>
                  <div class="table__data"></div>
                  <div class="table__data"></div>
                  <div class="table__data"></div>
                  <div class="table__data"></div>
                </div>
              </div>
            </div>
          </transition>

          <!-- if items are greater than a particular number-->
          <div class="show-more__gradient flex-box-mid" v-if="!recentPaymentsEmpty">
            <router-link :to="{name:'all-transfers'}" class="show-more__text">See all payments</router-link>
          </div>
        </div>

      </section>

      <!--recent payments-->
      <!--<section class="panel transactions">-->
        <!--<div class="panel__header">-->
          <!--<div class="panel__header__left">Recent <span>Approvals</span>-->
            <!--&lt;!&ndash; <div class="tag__notifications tag__notifications&#45;&#45;circle tag&#45;&#45;above-text" v-if="!isLoading">{{overviewData.transactions.length}}</div> &ndash;&gt;-->
          <!--</div>-->
        <!--</div>-->
        <!--<div class="panel__content panel__content&#45;&#45;grey">-->
          <!--&lt;!&ndash;if object is empty&ndash;&gt;-->
          <!--<div class="panel__empty" v-if="awaitingApprovalsEmpty">-->
            <!--<div class="panel__empty__icon empty__icon__approvals">-->
              <!--<svg enable-background="new 0 0 30 30" version="1.1" viewBox="0 0 30 30" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">-->
              <!--<g>-->
                <!--<path d="m28 15.35v-5.35h-2v-2h2v-8h-28v8h2v2h-2v8h2v2h-2v8h15.35c1.545 1.248 3.51 1.999 5.65 2 4.971-2e-3 8.998-4.029 9-9-1e-3 -2.143-0.752-4.105-2-5.65zm-26-11.35h4v2h-4v-2zm22 4v2h-20v-2h20zm-22 6h4v2h-4v-2zm4 12h-4v-2h4v2zm6.059-6h-8.059v-2h8.522c-0.225 0.639-0.387 1.307-0.463 2zm8.941 7.883c-3.801-9e-3 -6.876-3.084-6.885-6.883 9e-3 -3.801 3.084-6.876 6.885-6.885 3.799 9e-3 6.874 3.084 6.883 6.885-9e-3 3.799-3.084 6.874-6.883 6.883z"/>-->
                <!--<polygon points="20 21 18 19 16 21 20 25 26 19 24 17"/>-->
              <!--</g>-->
            <!--</svg>-->
            <!--</div>-->
            <!--<div class="panel__empty__text">You have no payments awaiting your approval.-->
              <!--<router-link :to="{name:'awaiting-approval'}" class="link">Approve a Transfer </router-link> to-->
              <!--<router-link :to="{name:'single-disburse'}" class="link">send money</router-link> to a beneficiary-->
            <!--</div>-->
          <!--</div>-->
          <!--&lt;!&ndash; Table Data &ndash;&gt;-->
          <!--<transition name="slide-fade">-->
            <!--<div class="table">-->
              <!--&lt;!&ndash; Table body &ndash;&gt;-->
              <!--<div class="table__section table__section&#45;&#45;body"  v-for="approval in overviewData.approvals">-->
                <!--&lt;!&ndash; table row &ndash;&gt;-->
                <!--&lt;!&ndash;<div  class="table">&ndash;&gt;-->
                <!--<div class="table__row">-->
                  <!--&lt;!&ndash; table data &ndash;&gt;-->

                  <!--<div class="table__data">-->
                    <!--<div class="table__data&#45;&#45;bold">-->
                      <!--<small class="table__data&#45;&#45;result">{{approval.model_values.disburseObject.currency}}</small> <br>-->
                      <!--{{ approval.model_values.disburseObject.amount | numeralize('0,0.00') }}-->
                    <!--</div>-->
                  <!--</div>-->
                  <!--&lt;!&ndash; table data &ndash;&gt;-->
                  <!--<div class="table__data">-->
                    <!--<div class="table__data&#45;&#45;default">{{approval.model_values.disburseObject.accountName}}</div>-->
                    <!--<div class="table__data&#45;&#45;sub">{{approval.model_values.disburseObject.accountNumber}}</div>-->
                  <!--</div>-->
                  <!--&lt;!&ndash; table data &ndash;&gt;-->
                  <!--<div class="table__data">-->
                    <!--<div class="table__data&#45;&#45;default">{{ createdAgo(approval.createdAt) }}</div>-->
                    <!--<div class="table__data&#45;&#45;sub">{{ momentDate(approval.createdAt) }}</div>-->
                  <!--</div>-->

                  <!--&lt;!&ndash; table data &ndash;&gt;-->
                  <!--<div class="table__data">-->
                    <!--<div class="table__data&#45;&#45;default">Ted A</div>-->
                    <!--<div class="table__data&#45;&#45;sub">Approved by</div>-->
                  <!--</div>-->

                  <!--&lt;!&ndash; table data &ndash;&gt;-->
                  <!--<div class="table__data">-->
                    <!--<div class="table__data&#45;&#45;default">For: <span class="table__data&#45;&#45;result"> {{ approval.model_values.disburseObject.Narration }} </span></div>-->
                  <!--</div>-->
                <!--</div>-->
                <!--<div class="table__row spacer"></div>-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--&lt;!&ndash;show if show more is true&ndash;&gt;-->
              <!--</div>-->
            <!--</div>-->
          <!--</transition>-->

          <!--&lt;!&ndash; if items are greater than a particular number&ndash;&gt;-->
          <!--<div class="show-more__gradient flex-box-mid" v-if="!awaitingApprovalsEmpty">-->
            <!--<router-link :to="{name:'approved-transfers'}" class="show-more__text">See all approved transfers</router-link>-->
          <!--</div>-->
        <!--</div>-->

      <!--</section>-->

      <!--recent approvals pending, show if user is account officer-->
      <section class="panel transactions">
        <div class="panel__header">
          <div class="panel__header__left">
            Payments <span>awaiting your approval</span>
            <div class="tag__notifications tag__notifications--circle tag--above-text notifications__multiple hide">20</div>
          </div>
        </div>
        <div class="panel__content panel__content--grey">

          <!--if object is empty-->
          <div class="panel__empty" v-if="awaitingApprovalsEmpty === true">
            <div class="panel__empty__icon empty__icon__approvals">
              <svg enable-background="new 0 0 30 30" version="1.1" viewBox="0 0 30 30" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
              <g>
                <path d="m28 15.35v-5.35h-2v-2h2v-8h-28v8h2v2h-2v8h2v2h-2v8h15.35c1.545 1.248 3.51 1.999 5.65 2 4.971-2e-3 8.998-4.029 9-9-1e-3 -2.143-0.752-4.105-2-5.65zm-26-11.35h4v2h-4v-2zm22 4v2h-20v-2h20zm-22 6h4v2h-4v-2zm4 12h-4v-2h4v2zm6.059-6h-8.059v-2h8.522c-0.225 0.639-0.387 1.307-0.463 2zm8.941 7.883c-3.801-9e-3 -6.876-3.084-6.885-6.883 9e-3 -3.801 3.084-6.876 6.885-6.885 3.799 9e-3 6.874 3.084 6.883 6.885-9e-3 3.799-3.084 6.874-6.883 6.883z"/>
                <polygon points="20 21 18 19 16 21 20 25 26 19 24 17"/>
              </g>
            </svg>
            </div>
            <div class="panel__empty__text">You have no payments awaiting your approval.</div>
            <router-link :to="{name:'single-disburse'}" class="link">send money</router-link> to a beneficiary
          </div>

          <!-- Table Data -->
          <transition class="slide-fade">
            <div class="table">
              <!-- Table body -->
              <div class="table__section table__section--body"  v-for="approval in overviewData.approvals">
                <!-- table row -->
                <!--<div  class="table">-->
                <div class="table__row" v-if="approval.name === 'disburse'">
                  <div class="table__data table__data--bold table__data--15">
                    <div class="table__data--default">
                      <span>Disburse</span><br>
                    </div>
                  </div>
                  <!-- table data -->

                  <div class="table__data">
                    <div class="table__data--bold table__data--10">
                      <small class="table__data--result">{{approval.model_values.disburseObject.currency}}</small> <br>
                      {{ approval.model_values.disburseObject.amount | numeralize('0,0.00') }}
                    </div>
                  </div>
                  <!-- table data -->
                  <div class="table__data table__data--20">
                    <div class="table__data--default">{{approval.model_values.disburseObject.accountName}}</div>
                    <div class="table__data--sub">{{approval.model_values.disburseObject.accountNumber}}</div>
                  </div>
                  <!-- table data -->
                  <div class="table__data">
                    <div class="table__data--default">{{ createdAgo(approval.createdAt) }}</div>
                    <div class="table__data--sub">{{ momentDate(approval.createdAt) }}</div>
                  </div>

                  <!-- table data -->
                  <div class="table__data table__data--15">
                    <div class="table__data--default">For: <br><small class="elip elip-max table__data--result">{{ approval.model_values.disburseObject.narration }} </small></div>
                  </div>

                  <div class="table__data">
                    <span class="tag" :class="['tag--' + approval.status]">{{approval.status}}</span>
                  </div>

                </div>
                <div class="table__row" v-else-if="approval.name === 'batch'">
                  <div class="table__data table__data--bold table__data--15">
                    <div class="table__data--default">
                      <span>Batch</span><br>
                    </div>
                  </div>
                  <!-- table data -->
                  <div class="table__data table__data--bold table__data--10">
                    <div class="table__data--bold">
                      <span>{{approval.model_values.currencyCode}}</span><br>
                    </div>
                  </div>
                  <!-- table data -->
                  <div class="table__data table__data--20">
                    <div class="table__data--default">{{approval.model_values.options.name}}</div>
                    <div class="table__data--sub">Ref: {{approval.model_values.options.ref}}</div>
                  </div>
                  <!-- table data -->
                  <div class="table__data">
                    <div class="table__data--default">{{ createdAgo(approval.createdAt) }}</div>
                    <div class="table__data--sub">{{ momentDate(approval.createdAt) }}</div>
                  </div>

                  <!-- table data -->
                  <div class="table__data table__data--15">
                    <div class="table__data--bold">
                      <small class="table__data--result">{{Object.keys(approval.model_values.recipients).length}}</small> <br>
                      <small class="table__data--sub">Total transactions</small>
                    </div>
                  </div>
                  <div class="table__data">
                    <span class="tag" :class="['tag--' + approval.status]">{{approval.status}}</span>
                  </div>
                </div>
                <div class="table__row spacer"></div>
                <!--</div>-->
                <!--show if show more is true-->
              </div>
              <div class="table__section table__section--body" v-if="!awaitingApprovalsEmpty">
                <div class="table__row table__row__empty">
                  <div class="table__data"></div>
                  <div class="table__data"></div>
                  <div class="table__data"></div>
                  <div class="table__data"></div>
                  <div class="table__data"></div>
                  <div class="table__data"></div>
                </div>
              </div>
            </div>
          </transition>



          <!-- if items are greater than a particular number-->
          <div class="show-more__gradient flex-box-mid" v-if="!awaitingApprovalsEmpty">
            <router-link :to="{name:'awaiting-approval'}" class="show-more__text">See all</router-link>
          </div>
        </div>

      </section>

      <!-- <toggle-button
        v-model="myDataVariable"
        :sync="true"
        color="#82C7EB"
        @change="onChangeEventHandler"
        :labels="true"
      /> -->

      <!--recent scheduled payments, show if user is account officer-->
      <section class="panel transactions" v-if="false">
        <div class="panel__header">
          <div class="panel__header__left">
            Scheduled <span>payments</span>
            <div class="tag__notifications tag__notifications--circle tag--above-text hide">9</div>
          </div>

        </div>
        <div class="panel__content panel__content--grey">

          <!--if object is empty-->
          <div class="panel__empty" v-if="scheduledPaymentsEmpty = true">
            <div class="panel__empty__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="92" height="70" viewBox="0 0 92 70"><g fill="none" fill-rule="evenodd" transform="translate(-1 -1)"><rect width="43" height="60" x="10" y="6" fill="#D6DBEB" opacity=".269" rx="3" transform="rotate(-22 31.5 36)"></rect> <rect width="43" height="60" x="41" y="6" fill="#D6DBEB" opacity=".269" rx="3" transform="rotate(22 62.5 36)"></rect> <g fill-rule="nonzero"><g transform="translate(47 45)"><path fill="#4B536B" d="M10.968.279a5.039 5.039 0 1 0 .001 10.077A5.039 5.039 0 0 0 10.968.28zm2.178 7.326c-.134.27-.32.495-.562.676a2.561 2.561 0 0 1-.859.408c-.13.037-.266.064-.404.086v.591h-.775v-.542a4.194 4.194 0 0 1-.562-.05 3.82 3.82 0 0 1-.569-.134 2.764 2.764 0 0 1-.418-.164 1.021 1.021 0 0 1-.244-.156.474.474 0 0 1-.118-.23 1.924 1.924 0 0 1-.042-.465c0-.135.004-.243.014-.324a.776.776 0 0 1 .042-.195c.019-.049.042-.082.069-.098a.21.21 0 0 1 .105-.024c.052 0 .127.029.227.087.101.058.225.122.374.191.149.071.322.135.52.195s.422.091.673.091c.159 0 .299-.015.422-.048s.23-.079.321-.14a.593.593 0 0 0 .207-.23.702.702 0 0 0 .069-.321.535.535 0 0 0-.128-.359 1.128 1.128 0 0 0-.343-.262 3.983 3.983 0 0 0-.481-.209 11.381 11.381 0 0 1-.552-.217 5.015 5.015 0 0 1-.55-.272 2.077 2.077 0 0 1-.482-.377 1.694 1.694 0 0 1-.341-.538 1.956 1.956 0 0 1-.13-.753c0-.297.058-.571.175-.82.116-.248.283-.461.503-.639.218-.176.485-.314.799-.412.14-.043.288-.077.443-.101v-.582h.775v.54a4.14 4.14 0 0 1 .907.143c.149.042.275.088.377.136.102.049.176.091.22.126a.315.315 0 0 1 .093.105.454.454 0 0 1 .043.126 2.556 2.556 0 0 1 .034.449c0 .126-.003.228-.01.307a.779.779 0 0 1-.035.189c-.016.045-.038.077-.065.093a.193.193 0 0 1-.098.025.484.484 0 0 1-.195-.073 3.307 3.307 0 0 0-.331-.157 4.035 4.035 0 0 0-.461-.157 2.205 2.205 0 0 0-.596-.073c-.159 0-.296.016-.412.049a.773.773 0 0 0-.286.14.61.61 0 0 0-.225.474c0 .145.044.266.134.363.088.098.204.184.349.258.144.076.307.145.491.21.184.064.37.136.558.213.189.077.375.166.559.268.183.102.348.228.491.377.145.149.261.327.349.534.088.207.132.452.132.736a2.148 2.148 0 0 1-.201.936z"></path> <circle cx="2.34" cy="5.317" r="1.679" fill="#D6DBEB"></circle> <circle cx="19.596" cy="5.317" r="1.679" fill="#D6DBEB"></circle></g> <path fill="#4B536B" d="M72.194 41.635H43.742c-.785 0-1.421.563-1.421 1.257v14.852c0 .694.636 1.257 1.421 1.257h28.451c.785 0 1.421-.563 1.421-1.257V42.892c.001-.695-.635-1.257-1.42-1.257zM44.59 54.338v-7.357c.987-.009 3.28-.352 3.286-3.34h20.221c.017.994.381 3.197 3.25 3.247v7.377c-.963.036-2.84.409-3.122 2.729h-20.32c-.164-1.108-.837-2.65-3.315-2.656z"></path> <g fill="#4B536B"><path d="M35.6 25.5h4.466v4.466H35.6zM43.615 25.5h4.466v4.466h-4.466zM51.631 25.5h4.466v4.466h-4.466zM27.584 32.291h4.466v4.466h-4.466zM27.584 25.5h4.466v4.466h-4.466zM35.6 32.291h4.466v4.466H35.6zM43.615 32.291h4.466v4.466h-4.466zM51.631 32.291h4.466v4.466h-4.466zM27.584 39.081h4.466v4.466h-4.466zM39.724 42.892c0-.553.123-1.079.342-1.554v-2.256H35.6v4.466h4.124v-.656z"></path> <g><path d="M31.147 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.669 1.488-1.488 1.488zM41.873 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.669 1.488-1.488 1.488zM52.599 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.67 1.488-1.488 1.488z"></path> <path d="M57.022 12.124h-1.079v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636h-3.974v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636h-3.974v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636H26.66c-4.563 0-8.274 3.712-8.274 8.274v20.375c0 4.563 3.712 8.274 8.274 8.274h13.064v-3.711H26.66a4.568 4.568 0 0 1-4.563-4.563V23.435h39.489v15.602h3.711V20.399c-.001-4.563-3.712-8.275-8.275-8.275z"></path></g></g></g></g></svg>
            </div>
            <div class="panel__empty__text">You have no scheduled payments</div>
          </div>

          <!-- Table Data -->
          <div class="table" v-if="scheduledPaymentsEmpty = false">
            <!-- Table body -->
            <div class="table__section table__section--body">
              <!-- table row -->
              <div class="table__row">
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--bold">
                    $ 12,280,000
                  </div>
                </div>
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--default">JR Washington</div>
                  <div class="table__data--sub">GTB Bank (****2086))</div>
                </div>
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--default positionRelative">Today
                    <div class="tag__time tag--above-text">08<span>:</span>54</div>
                  </div>
                  <div class="table__data--sub">Oct 23, 2017</div>
                </div>


                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--default">Scheduled by: <span class="table__data--result"> Yele </span></div>

                </div>

                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--actions textRight">
                    <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                    <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                  </div>
                </div>
              </div>

              <div class="table__row spacer"></div>

              <!-- table row -->
              <div class="table__row">
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--bold">
                    $ 12,280,000
                  </div>
                </div>
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--default">JR Washington</div>
                  <div class="table__data--sub">GTB Bank (****2086))</div>
                </div>
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--default positionRelative">Today
                    <div class="tag__time tag--above-text">08<span>:</span>54</div>
                  </div>
                  <div class="table__data--sub">Oct 23, 2017</div>
                </div>


                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--default">Scheduled by: <span class="table__data--result"> Felix (You) </span></div>

                </div>

                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--actions textRight">
                    <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                    <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                  </div>
                </div>
              </div>

              <div class="table__row spacer"></div>

              <!-- table row -->
              <div class="table__row">
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--bold">
                    $ 12,280,000
                  </div>
                </div>
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--default">JR Washington</div>
                  <div class="table__data--sub">GTB Bank (****2086))</div>
                </div>
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--default positionRelative">Today
                    <div class="tag__time tag--above-text">08<span>:</span>54</div>
                  </div>
                  <div class="table__data--sub">Oct 23, 2017</div>
                </div>


                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--default">Scheduled by: <span class="table__data--result"> Tolu </span></div>

                </div>

                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--actions textRight">
                    <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                    <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                  </div>
                </div>
              </div>

              <div class="table__row spacer"></div>

              <!-- table row -->
              <div class="table__row">
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--bold">
                    $ 12,280,000
                  </div>
                </div>
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--default">JR Washington</div>
                  <div class="table__data--sub">GTB Bank (****2086))</div>
                </div>
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--default positionRelative">Today
                    <div class="tag__time tag--above-text">08<span>:</span>54</div>
                  </div>
                  <div class="table__data--sub">Oct 23, 2017</div>
                </div>


                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--default">Scheduled by: <span class="table__data--result"> Yele </span></div>

                </div>

                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--actions textRight">
                    <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                    <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                  </div>
                </div>
              </div>

              <div class="table__row spacer"></div>

              <!--show if show more is true-->
              <div class="table__row table__row__empty">
                <div class="table__data"></div>
                <div class="table__data"></div>
                <div class="table__data"></div>
                <div class="table__data"></div>
                <div class="table__data"></div>
              </div>

            </div>
          </div>

          <!-- if items are greater than a particular number-->
          <div class="show-more__gradient flex-box-mid" v-if="scheduledPaymentsEmpty = false">
            <router-link :to="{name:'scheduled-transfers'}" class="show-more__text">See all scheduled payments</router-link>
          </div>

        </div>
      </section>
    </div>

  </div>
</template>


<script>
  import {getSummary, globalSearch, getPaymentSummary} from '../../utils/overview/overviewService'
  import {getUser} from '../../utils/user/getUserDetails'
  import {toLowerCase} from '../../utils/helpers/utilitiesService'
  // import {login} from '../../utils/auth/authService'
  import { mapMutations } from 'vuex'
  import ta from 'time-ago';
  import moment from 'moment'
  // import appConfig from '@/config';
  // const STAGING_PASSWORD = appConfig.api.staginPassword;
  // let baseUrl = appConfig.api.orinalBase;

  export default {

    mounted(){
      this.loadDashboardSummary();
      this.paymentSummary(1);
      // this.getFilteredData('ANGUS BROWn');
    },


    data() {
      return {
        showModal: false,
        overviewData:{},
        paymentSummaryTodayEmpty:false,
        paymentSummaryWeekEmpty:false,
        recentPaymentsEmpty:false,
        scheduledPaymentsEmpty:false,
        awaitingApprovalsEmpty:false,
        isLoading: true,
        walletList:[],
        currencySelected:'NGN',
        // myDataVariable: this.change(),
        paymentSummaryToday: {},
        paymentSummaryWeek: {},
      }
    },
    components:{

    },
    methods:{
      // change() {
      //   if (window.localStorage.getItem('staging') === 'true') return true;
      //   else return false;
      // },
      // onChangeEventHandler() {
      //   console.log(this.myDataVariable);
      //   window.localStorage.setItem('staging', this.myDataVariable);
      //   if (this.myDataVariable == true) {
      //     login(window.localStorage.getItem('userEmail'), STAGING_PASSWORD, true)
      //     .then((response) => {
      //       let token = response.data.token_type + ' ' + response.data.access_token;
      //       window.localStorage.setItem('stagingToken', token);
      //       window.localStorage.setItem('token', token);
      //       console.log('token', window.localStorage.getItem('token'));
      //       console.log('Staging', window.localStorage.getItem('stagingToken'));
      //       console.log('Production', window.localStorage.getItem('productionToken'));
      //       this.getUserDetails();
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //     });
      //   } else if (this.myDataVariable == false) {
      //     window.localStorage.setItem('token', window.localStorage.getItem('productionToken'));
      //     console.log('token', window.localStorage.getItem('token'));
      //     console.log('Production', window.localStorage.getItem('productionToken'));
      //     console.log('Staging', window.localStorage.getItem('stagingToken'));
      //     this.getUserDetails(baseUrl);
      //   }
      // },
      // getUserDetails(url = false){
      //   //after login is successful, get user details.
      //   getUser(url)
      //     .then(responseUser =>{
      //       this.$Progress.start();
      //       //cache user details if getuser api call is successful
      //       if(responseUser.status === 200){
      //         //route to overview on success

      //         console.log(responseUser);
      //         this.$store.commit('updateMerchantList', responseUser.data.merchants);
      //         this.$store.commit('updateUserFirstName', responseUser.data.name)
      //         this.$store.commit('updateUserPhonenumber', responseUser.data.phonenumber)
      //         this.$store.commit('updateUserEmail', responseUser.data.email)
      //         this.$store.commit('updateUserBusinessName', responseUser.data.merchants[0].name)
      //         this.$store.commit('updateUserAccountNumber', responseUser.data.merchants[0].account);
      //         this.$store.commit('updateCompliance', responseUser.data.merchants[0].compliance);
      //         this.$store.commit('updateUserMerchantId', responseUser.data.merchants[0].id)
      //         console.log(this.$store.state.authUser.phoneNumber);
      //         console.log(this.$store.state.authUser.compliance);
      //         console.log(this.$store.state.authUser.merchantList);
      //         this.$router.push('/overview'); location.reload();
      //       }
      //     })

      //   //catch error from the getuser API and do something about the errors
      //   .catch(error =>{
      //       this.$Progress.fail()
      //       console.log(this.errors);
      //   })
      // },
      momentDate(date){
        return moment(date).format('MMM DD, YYYY')
      },
      paymentSummary(currencyId) {
        getPaymentSummary(currencyId).then((resp) => {
          if (resp.status === 200) {
            this.paymentSummaryToday = resp.data.data.payouts_today[0] || {};
            this.paymentSummaryWeek = resp.data.data.payouts_this_week[0] || {};
          }
        }).catch(errors =>{
          console.log(errors);
        });
      },
      createdAgo(time) {
        return ta.ago(time);
      },
      //return value to lower case
      toLowerCase(value){
        return value.toLowerCase()
      },
      getFilteredData(data){
        globalSearch(data).then((response)=> {
        }).catch((error)=>{
            console.log(error);
        })
      },
      loadDashboardSummary(){
        //get dashboard summary
        getSummary()
          .then(response => {
            if(response.status === 200){
              this.$Progress.finish();
              this.isLoading = false;
              this.overviewData = response.data.data;
              //empty wallet first before storage
              this.$store.commit('emptyPrimaryCurrencies');
              console.log(this.overviewData);
              //commit wallets to localstorage
              if (Object.keys(this.overviewData.wallets).length < 1) {
                window.localStorage.setItem('walletList', []);
              } else {
                this.overviewData.wallets.forEach((wallet)=>{
                console.log(wallet);
                this.$store.commit('updatePrimaryWalletCurrencies', {
                  currencyCode: wallet.currency.shortCode,
                  currencyId:wallet.id,
                  currencyBalance:wallet.balance,
                  currencyUref:wallet.uref,
                  country: wallet.currency.countryTag,
                  countryName: wallet.currency.countryName,
                  name: wallet.name,
                });
              });
              }

              //check if the payment summary week returned is empty
              if(!this.overviewData.payouts_this_week || this.overviewData.payouts_this_week.length === 0){
                this.paymentSummaryWeekEmpty = true;
              }

              //check if the payment summary today returned is empty
              if(!this.overviewData.payouts_today || this.overviewData.payouts_today.length === 0){
                this.paymentSummaryTodayEmpty = true;
              }

              //check if the transaction object returned is empty
              if(!this.overviewData.transactions || this.overviewData.transactions.length === 0){
                this.recentPaymentsEmpty = true;
              }

              //check if the scheduled payments object returned is empty
              if(!this.overviewData.scheduled_payments || this.overviewData.scheduled_payments.length === 0){
                this.scheduledPaymentsEmpty = true;
              }

              //check if the approvals object returned is empty
              if(!this.overviewData.approvals || this.overviewData.approvals.length === 0){
                this.awaitingApprovalsEmpty = true;
              }
              else if(this.overviewData.approvals.length > 0){
                Object.keys(this.overviewData.approvals).forEach((reply) =>{
                  this.overviewData.approvals[reply].model_values = JSON.parse(this.overviewData.approvals[reply].model_values);
                  if(this.overviewData.approvals[reply].model_values.disburseObject && this.overviewData.approvals[reply].model_values.disburseObject.Narration !== '' && this.overviewData.approvals[reply].model_values.disburseObject.Narration){
                  }
                  else if (this.overviewData.approvals[reply].model_values.disburseObject){
                    this.overviewData.approvals[reply].model_values.disburseObject.Narration = 'Unspecified';
                  }
                })
              }
            }

          })
          .catch(errors =>{
            console.log(errors);
          })
      },
    },

    computed:{
      filteredPaymentSummaryWeek(){
        return {};
        // if(!this.paymentSummaryWeekEmpty){
        //   let filterString = this.currencySelected,
        //     paymentSummaryWeek = this.overviewData.payouts_this_week;

        //   const result = paymentSummaryWeek.filter(totalWeek => totalWeek.currency === filterString);

        //   return {
        //     amount: (result[0]) ? result[0].value_today : 0,
        //     volume: (result[0]) ? result[0].volume_today : 0,
        //   }
        // }
      },

      filteredPaymentSummaryToday(){
        return {};
        // if(!this.paymentSummaryTodayEmpty){
        //   let filterString = this.currencySelected,
        //     paymentSummaryDaily = this.overviewData.payouts_today;

        //   const result = paymentSummaryDaily.filter(totalDaily => totalDaily.currency === filterString);
        //   return {
        //     amount: (result[0]) ? result[0].value_today : 0,
        //     volume: (result[0]) ? result[0].volume_today : 0,
        //   }
        // }

      }


    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardOverview.vue